/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .option[_ngcontent-%COMP%]{width:33%;height:50px;border:2px solid #485056;box-sizing:border-box;background-color:#fff;margin-left:-6px;vertical-align:middle}[_nghost-%COMP%]   .option.active[_ngcontent-%COMP%]{color:#fff;background-color:#485056}[_nghost-%COMP%]:first-child   .option[_ngcontent-%COMP%]{margin-left:0;border-radius:30px 0 0 30px}[_nghost-%COMP%]:last-child   .option[_ngcontent-%COMP%]{border-radius:0 30px 30px 0}"];
export { styles as styles };
